const initialState = {
    count: 1
};

export default function reducer(state = initialState, action) {
    console.log('reducer', state, action);
    return state;
}